import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "add-variant-dialog" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_entry_search = _resolveComponent("entry-search")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createBlock(_component_entry_search, {
      key: _ctx.collection,
      show: _ctx.catalogueProductId !== null,
      "content-type": "product",
      payload: _ctx.collection,
      model: _ctx.model,
      "query-handler": _ctx.queryHandler,
      size: "medium",
      style: {"min-width":"320px","z-index":"9999"},
      onSelection: _cache[0] || (_cache[0] = ($event: any) => {_ctx.$emit('add-variants', $event); _ctx.$emit('update:catalogue-product-id', null)}),
      onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:catalogue-product-id', null)))
    }, null, 8, ["show", "payload", "model", "query-handler"]))
  ]))
}